const collectionDetail = {
  title: "All Product Collections",
  subtitle: "Discover groups of products curated by {{- storeName}}.",
  collectionsMenuLabel: "Collections",
  empty: "This collection is empty",
  errorTitle: "Something went wrong",
  errorBody: "We couldn't load this collection. Refresh the page to try again.",
  errorLoadingCollection: "Error loading collection data",
} as const;

export { collectionDetail };
